module.exports = __webpack_public_path__ + "img/banner_m.1d43cfd8.png";